import { Group } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { IconPlayerPause, IconTrash } from '@tabler/icons-react'
import { useIntl } from 'react-intl'
import { useHasPermissions } from '@/permissions/useHasPermissions'
import { DeploymentGroup, DeploymentGroupMember } from '@/types/deploymentGroup'
import { CrudAction, Resource } from '@/types/permissions'
import { ActionButton } from '../DeploymentList/DeploymentListActions'
import { MemberPauseConfirm } from './MemberPauseConfirm'
import { MemberRemoveConfirm } from './MemberRemoveConfirm'
import { DeploymentTreeGroupContext } from './deploymentTreeTypes'
import { canPauseGroup } from './groupActionVisibility'

const iconStyle = { width: '70%', height: '70%' }

type GroupMemberActionsProps = {
  member: DeploymentGroupMember
  group: DeploymentGroup
  context: DeploymentTreeGroupContext
}

export const GroupMemberActions = ({
  member,
  group,
  context
}: GroupMemberActionsProps) => {
  const intl = useIntl()

  const [isPauseOpen, { open: openPause, close: closePause }] =
    useDisclosure(false)
  const [isRemoveOpen, { open: openRemove, close: closeRemove }] =
    useDisclosure(false)

  const [canUpdateDeployment, canDeleteDeployment] = useHasPermissions(
    Resource.Deployments,
    [CrudAction.Update, CrudAction.Delete]
  )

  return (
    <Group wrap="nowrap" gap={8} justify="end">
      {canUpdateDeployment && canPauseGroup(group.status) && (
        <ActionButton
          tooltip={intl.formatMessage({
            id: 'deployments.groups.member.pause.tooltip'
          })}
          icon={<IconPlayerPause style={iconStyle} />}
          color="yellow"
          onClick={openPause}
        />
      )}

      {canDeleteDeployment && (
        <ActionButton
          tooltip={intl.formatMessage({
            id: 'deployments.groups.member.remove.tooltip'
          })}
          icon={<IconTrash style={iconStyle} />}
          color="red"
          onClick={openRemove}
        />
      )}

      <MemberPauseConfirm
        opened={isPauseOpen}
        member={member}
        group={group}
        context={context}
        onClose={closePause}
      />

      <MemberRemoveConfirm
        opened={isRemoveOpen}
        member={member}
        group={group}
        context={context}
        onClose={closeRemove}
      />
    </Group>
  )
}
